//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { db } from "../main.js";
export default {
  name: "Admin",
  data() {
    return {
      isCreating: false,
      editKey: null,
      classes: null,
      lessons: {},
      newLesson: {
        index: 0,
        YTID: "DkfRfZY5HwA",
        title: "Routine Overview",
        instructor: "Amanda375",
        description: "This is a description",
        backCamSrc: "DkfRfZY5HwA",
        backCamStart: 0,
        backCamEnd: 0,
        backCamSrcOffset: 0,
      },
    };
  },
  computed: {},
  methods: {
    addLesson(data) {
      data.YTID = this.cleanYTID(data.YTID);
      data.backCamSrc = this.cleanYTID(data.backCamSrc);
      console.log("YTID:" + data.YTID);
      var lessonid = db
        .ref(`lessons/${this.$store.state.currentClassKey}`)
        .push().key;
      db.ref(`lessons/${this.$store.state.currentClassKey}/${lessonid}`).set(
        data
      );
      this.isCreating = false;
    },
    cleanYTID(YTID) {
      if (YTID.length > 11) {
        return YTID.substring(YTID.length - 11);
      } else {
        return YTID;
      }
    },
  },
  async created() {
    this.$store.dispatch("setClassByKey", this.$route.params.classKey);
    await this.$store.dispatch(
      "setLessonsByClassKey",
      this.$route.params.classKey
    );
    var totalDuration = 0;
    this.$store.state.lessonsArray.forEach((lesson) => {
      totalDuration += parseFloat(lesson.duration / 60);
    });
    db.ref(`classes/${this.$route.params.classKey}/lessonCount`).set(
      this.$store.state.lessonsArray.length
    );
    db.ref(`classes/${this.$route.params.classKey}/totalDuration`).set(
      Math.round(totalDuration)
    );
  },
  mounted() {},
};
